/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutputForm_circle$ref: FragmentReference;
declare export opaque type OutputForm_circle$fragmentType: OutputForm_circle$ref;
export type OutputForm_circle = {|
  +id: string,
  +databaseId: string,
  +isGovernanceEnabled: boolean,
  +supportedRole: ?{|
    +id: string,
    +isExpanded: boolean,
    +circle: ?{|
      +localizedName: string
    |},
  |},
  +$refType: OutputForm_circle$ref,
|};
export type OutputForm_circle$data = OutputForm_circle;
export type OutputForm_circle$key = {
  +$data?: OutputForm_circle$data,
  +$fragmentRefs: OutputForm_circle$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutputForm_circle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGovernanceEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "supportedRole",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExpanded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Circle",
          "kind": "LinkedField",
          "name": "circle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "localizedName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Circle",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '54c67495dba0701113289e5fe450e0c7';

module.exports = node;
